:host {
  display: block;
  --limitnew: calc(var(--limit) + 1);
}

.switcher > * {
  display: flex;
  flex-wrap: wrap;
  margin: calc((var(--space) / 2) * -1);
}

.switcher > * > * {
  flex-grow: 1;
  flex-basis: calc((var(--threshold) - (100% - var(--space))) * 999);
  margin: calc(var(--space) / 2);
}
